import { inject, injectable } from "inversify";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IF360Validator } from "@/core/validators/F360Validator";
import "reflect-metadata";

const ADMIN_GESTAO_CONTRATOS_GROUPS = ["Developer", "Admin"];

@injectable()
export default class AdminGestaoContratosValidator implements IF360Validator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  private userProfileMixin!: IUserProfileStorageMixin;

  handleValidation(): boolean {
    const profile = this.userProfileMixin.handleGetUserProfile();
    const grupoDeUsuarios = profile?.AdminRoles?.GrupoDeUsuarios;

    return ADMIN_GESTAO_CONTRATOS_GROUPS.includes(grupoDeUsuarios || "");
  }
}
